import { call, put, takeEvery } from "redux-saga/effects"
import _ from 'lodash';

// Crypto Redux States
import { GET_SUBSCRIPTION_RULES , ADD_NEW_SUBSCRIPTION_RULE , UPDATE_SUBSCRIPTION_RULE } from "./actionTypes"

import {
  getSubscriptionRulesSuccess
} from "./actions"

//Include Both Helper File with needed methods
import { API_ENDPOINTS } from "api/endpoints"
import { history } from "helpers/utils"
import { Toast } from "helpers/Toast"


function* fetchSubscriptionRules(data) {
  try {
    const response = yield call(API_ENDPOINTS.getSubscriptionRulesList, {queryStringParameters: data.payload})
    yield put(getSubscriptionRulesSuccess(response))
  } catch (error) {
    Toast('error', error)
  }
}


function* onAddNewSubscriptionRule(data) {
  try {
    let res = yield call(API_ENDPOINTS.createOrEditSubscriptionRule, {body: data.payload})
  } catch (error) {
    Toast('error', error)
  }
}

function* updateSubscriptionRuleDetail(data) {
  try {
    let body = {
      body: data.payload,
      queryStringParameters: {
        imageId: data.payload._id
      }
    }
    yield call(API_ENDPOINTS.createOrEditSubscriptionRule, body)

  } catch (error) {
    console.log('error', error)
    Toast('error', error)
  }
}

function* wordsSaga() {
  yield takeEvery(GET_SUBSCRIPTION_RULES, fetchSubscriptionRules)
  yield takeEvery(ADD_NEW_SUBSCRIPTION_RULE, onAddNewSubscriptionRule)
  yield takeEvery(UPDATE_SUBSCRIPTION_RULE, updateSubscriptionRuleDetail)
}

export default wordsSaga;
